var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OTabs',_vm._b({attrs:{"type":"segment","value":_vm.active},on:{"input":_vm.onChange}},'OTabs',Object.assign({}, _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }